import React, { useState, useEffect } from "react";
import { backendURL } from "../Globals";
import { Table, Row, Col, Alert, Spin, Select, InputNumber, Button } from "antd";
import Cookies from "js-cookie";

const { Option } = Select;

const AssignedComponent = () => {
  const [assigned, setAssigned] = useState([]);
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [editingData, setEditingData] = useState({});

  useEffect(() => {
    checkAuth();
    getAssigned();
  }, []);

  const checkAuth = () => {
    const apiKey = Cookies.get("apiKey") || localStorage.getItem("apiKey");
    setIsLoggedIn(!!apiKey);
  };

  const getAssigned = async () => {
    setLoading(true);
    const apiKey = Cookies.get("apiKey") || localStorage.getItem("apiKey");

    if (!apiKey) {
      setMessage("Authentication error. Please log in.");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${backendURL}/assigned`, {
        headers: {
          Authorization: `Bearer ${apiKey}`,
        },
      });

      if (response.ok) {
        const jsonData = await response.json();

        const uniqueYears = [...new Set(jsonData.map((item) => item.year))].sort((a, b) => b - a);
        setYears(uniqueYears);
        setSelectedYear(uniqueYears[0]);
        setAssigned(jsonData);
      } else {
        setMessage("Failed to load data.");
      }
    } catch (error) {
      console.error("Error fetching assigned data:", error);
      setMessage("Network error: Unable to fetch data. Please check your connection.");
    } finally {
      setLoading(false);
    }
  };

  const handleYearChange = (year) => {
    setSelectedYear(year);
  };

  const handleEditChange = (id, value) => {
    setEditingData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleUse = async (id, delta) => {
    const apiKey = Cookies.get("apiKey") || localStorage.getItem("apiKey");
    if (!apiKey) return;
    try {
      await fetch(`${backendURL}/assigned/${id}/use`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${apiKey}` },
        body: JSON.stringify({ delta }),
      });
      getAssigned();
    } catch (error) {
      console.error("Error updating used count:", error);
    }
  };

  const handleSaveEdit = async (id) => {
    const apiKey = Cookies.get("apiKey") || localStorage.getItem("apiKey");

    if (!apiKey) {
      setMessage("Authentication error. Please log in.");
      return;
    }

    const newApcValue = editingData[id];
    if (newApcValue == null) return;

    try {
      const response = await fetch(`${backendURL}/assigned/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiKey}`,
        },
        body: JSON.stringify({
          apc_count: newApcValue,
        }),
      });

      if (response.ok) {
        getAssigned();
        setEditingData((prevData) => ({
          ...prevData,
          [id]: undefined,
        }));
      } else {
        setMessage("Failed to update APC count.");
      }
    } catch (error) {
      console.error("Error updating APC count:", error);
      setMessage("Network error: Unable to update data.");
    }
  };

  const columns = [
    {
      title: "Editor",
      dataIndex: "editor",
      key: "editor",
      width: 150,
    },
    {
      title: "Total asignados",
      dataIndex: "apc_count",
      key: "apc_count",
      align: "center",
      render: (text, record) =>
        isLoggedIn ? (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <InputNumber
              min={-1}
              value={editingData[record.id] ?? text}
              onChange={(value) => handleEditChange(record.id, value)}
              style={{ width: 80 }}
            />
            <Button size="small" type="primary" onClick={() => handleSaveEdit(record.id)}>
              Guardar
            </Button>
          </div>
        ) : (
          <span style={{ fontWeight: 600 }}>{text === -1 ? "Ilimitados" : text}</span>
        ),
    },
    {
      title: "Consumidos",
      key: "consumidos",
      align: "center",
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
          <Button
            size="small"
            style={{ fontWeight: 700, fontSize: 16, lineHeight: 1, padding: "0 10px" }}
            onClick={() => handleUse(record.id, -1)}
            disabled={record.used_count <= 0}
          >−</Button>
          <span style={{ minWidth: 28, textAlign: "center", fontWeight: 600, fontSize: 16 }}>{record.used_count}</span>
          <Button
            size="small"
            style={{ fontWeight: 700, fontSize: 16, lineHeight: 1, padding: "0 10px" }}
            onClick={() => handleUse(record.id, 1)}
            disabled={record.apc_count !== -1 && record.used_count >= record.apc_count}
          >+</Button>
        </div>
      ),
    },
    {
      title: "APCs disponibles",
      key: "disponibles",
      align: "center",
      render: (_, record) => {
        if (record.apc_count === -1) {
          return <span style={{ color: "#1677ff", fontWeight: 700, fontSize: 20 }}>∞</span>;
        }
        const disp = record.apc_count - record.used_count;
        const color = disp <= 0 ? "#ff4d4f" : disp <= 5 ? "#fa8c16" : "#52c41a";
        return <span style={{ color, fontWeight: 700, fontSize: 22 }}>{Math.max(0, disp)}</span>;
      },
    },
  ];

  return (
    <Row justify="center" style={{ marginTop: "50px" }}>
      <Col span={14}>
        {message && <Alert message={message} type="error" style={{ marginBottom: "20px" }} />}
        <div style={{ marginBottom: "20px", textAlign: "center" }}>
          <h3>Selecciona un año</h3>
          <Select value={selectedYear} onChange={handleYearChange} style={{ width: 150 }}>
            {years.map((year) => (
              <Option key={year} value={year}>
                {year}
              </Option>
            ))}
          </Select>
        </div>
        {loading ? (
          <Spin size="large" style={{ display: "block", margin: "20px auto" }} />
        ) : (
          <Table
            columns={columns}
            dataSource={[...assigned.filter((item) => item.year === selectedYear)].sort((a, b) => {
              if (a.apc_count === -1 && b.apc_count !== -1) return 1;
              if (a.apc_count !== -1 && b.apc_count === -1) return -1;
              return b.apc_count - a.apc_count;
            })}
            rowKey={(record) => record.id}
            pagination={false}
            style={{
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              borderRadius: "10px",
              maxHeight: "70vh",
              overflowY: "auto",
            }}
          />
        )}
      </Col>
    </Row>
  );
};

export default AssignedComponent;
